// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"a0f00e9e","240":"464f14de","241":"47b23d05","300":"16f2cb0e","395":"d710b37f","570":"b93a18e1","617":"80ed75a3","649":"4da9c21a","754":"7f22d4ab","960":"e602e849"}[chunkId] + ".chunk.js";
};